import { render } from "./PccdDashboard.vue?vue&type=template&id=44c312d1&scoped=true"
import script from "./PccdDashboard.vue?vue&type=script&lang=js"
export * from "./PccdDashboard.vue?vue&type=script&lang=js"

import "./PccdDashboard.vue?vue&type=style&index=0&id=44c312d1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44c312d1"]])

export default __exports__